/**
 * Builds an `"${prefix}.${index}.${field}"` react-hook-form field name, typed as index 0.
 * Passing a raw `` `...${index}...` `` template literal to setValue/getValues/useWatch makes
 * the checker match a `${number}` template against the form's entire Path union (seconds of
 * check time and significant memory per call site); a concrete literal path is a cheap union
 * membership lookup while still being validated against the real form paths.
 */
export const indexedFieldName = <TPrefix extends string, TField extends string>(
    prefix: TPrefix,
    index: number,
    field: TField
): `${TPrefix}.0.${TField}` => `${prefix}.${index}.${field}` as `${TPrefix}.0.${TField}`;
